import { DoneIcon, LogoLocalinaIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '../Page';

const BENEFITS = ['allDay', 'onePlace', 'fewerCalls'] as const;

interface IProps {
    name: string;
    title: string;
    subtitle?: string;
    isLoading?: boolean;
    children?: React.ReactNode;
}

/**
 * Shell for the signed-out pages: the brand panel on the left, the form on the right.
 * On phones the brand panel shrinks to a header and the benefits move below the form.
 */
export const AuthLayout: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    const benefits = (
        <ul className="auth-layout__benefits">
            {BENEFITS.map((key) => (
                <li key={key}>
                    <span className="auth-layout__check">
                        <DoneIcon />
                    </span>
                    {t(`auth.brand.benefits.${key}`)}
                </li>
            ))}
        </ul>
    );

    return (
        <Page name={`auth ${props.name}`} isLoading={props.isLoading}>
            <div className="auth-layout">
                <aside className="auth-layout__brand">
                    <div className="auth-layout__logo">
                        <LogoLocalinaIcon />
                    </div>
                    <div className="auth-layout__pitch">
                        <h2 className="auth-layout__headline">{t('auth.brand.headline')}</h2>
                        <p className="auth-layout__lead">{t('auth.brand.lead')}</p>
                        <p className="auth-layout__lead auth-layout__lead--short">{t('auth.brand.leadShort')}</p>
                        {benefits}
                    </div>
                    <div className="auth-layout__byline">{t('auth.brand.byline')}</div>
                </aside>
                <section className="auth-layout__main">
                    <div className="auth-layout__form">
                        <h1 className="auth-layout__title">{props.title}</h1>
                        {props.subtitle && <p className="auth-layout__subtitle">{props.subtitle}</p>}
                        {props.children}
                    </div>
                    <div className="auth-layout__why">
                        <div className="auth-layout__why-title">{t('auth.brand.whyTitle')}</div>
                        {benefits}
                    </div>
                </section>
            </div>
        </Page>
    );
};
